(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kc-marquee"] && !Shopify.designMode) return;
  try {
    
const initializeMarquee = () => {
  const marqueeWrapper = document.querySelector('.kc-marquee-wrapper');
  const marqueeTrack = document.querySelector('.kc-marquee-track');

  if (!marqueeWrapper || !marqueeTrack) {
    return;
  }

  let animationFrameId;
  let isPaused = false;
  let currentPosition = 0;
  const speed = 0.5; 

  function animateMarquee() {
    if (!isPaused) {
      currentPosition -= speed;
      const trackWidth = marqueeTrack.scrollWidth / 2;
      if (currentPosition <= -trackWidth) {
        currentPosition = 0;
      }
      marqueeTrack.style.transform = `translateX(${currentPosition}px)`;
    }
    animationFrameId = requestAnimationFrame(animateMarquee);
  }

  marqueeWrapper.addEventListener('mouseenter', () => {
    isPaused = true;
  });

  marqueeWrapper.addEventListener('mouseleave', () => {
    isPaused = false;
  });

  animateMarquee();
};

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      const marqueeWrapper = document.querySelector('.kc-marquee-wrapper');
      if (marqueeWrapper) {
        initializeMarquee();
        observer.disconnect(); 
      }
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
